
/* styles */
require("!!../../../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-bfa35d02&scoped=true!sass-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./contact.vue")

var Component = require("!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./contact.js"),
  /* template */
  require("!!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-bfa35d02!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./contact.vue"),
  /* scopeId */
  "data-v-bfa35d02",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/modal/aggregate-register/contact.vue
// module id = 515
// module chunks = 1